import Marquee from "react-fast-marquee";

const WORDS = ["Arbitration", "Matrimonial", "Property Law", "Writ Petitions", "Arbitration", "Domestic Violence", "Tender Matters"];

export const MarqueeStrip = () => (
  <div data-testid="marquee-strip" className="bg-white border-y border-[#E5E7EB] py-6 md:py-8">
    <Marquee speed={38} gradient={false}>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif-display italic text-[#0A1128] text-3xl md:text-5xl px-8 md:px-14">{w}</span>
          <span className="text-[#D4AF37] text-2xl">&#10022;</span>
        </span>
      ))}
    </Marquee>
  </div>
);
